import { gql } from '@apollo/client';

const signInMutation = gql`
  mutation SignInMutation($email: String!, $password: String!) {
    userSignIn(email: $email, password: $password) {
      id
      model_id
    }
  }
`;

export default signInMutation;
